import { Component } from '@angular/core';

const template = require('!!raw-loader!./anniversary-logo.component.svg').default;

@Component({
    selector: 'anniversary-logo',
    template,
    styleUrls: ['./anniversary-logo.component.less'],
})
export class AnniversaryLogoComponent {
}
